import './core/capeLogger';
import axios from 'axios';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './framework/App/App';
import postMiniBrowserMessage from './core/postMiniBrowserMessage';
import {FLOW_TYPE, WINDOW_NAME_PPFRAME} from './framework/App/AppConstants';
import {CONTEXT_TYPE} from './framework/App/SkeletonPage/SkeletonPageConstants';
import _ from 'lodash';


// this function sets up the behavior for when the mini-browser window is
// manually closed
export const setupReturnBehavior = () => {
    if (window.isTransactionalFlow) {

        // checkout.js/sdk updates
        if (window.xprops && window.xprops.init) {
            return window.xprops.init(JSON.parse(window.checkoutJSPostData));
        }

        if (window.shouldPostMessage) {
            postMiniBrowserMessage(window.browserWindowClosePostMessage);
        }
    }
};

function isCheckoutXComponent() {
    return Boolean(
        window.paypal &&
        window.paypal.isCheckoutXComponent &&
        window.paypal.isCheckoutXComponent() &&
        window.paypal.onLoadCheckoutIntegration
    );
}

const updateContextTypeOnServer = (initialState) => {
    const { serverData = {} } = initialState;
    const { _csrf = '', contextType = ''} = serverData;
    return axios
        .request({
            method: 'post',
            url: 'session',
            headers: {
                'X-CSRF-Token': _csrf
            },
            data: {
                contextType
            }
        }).catch(error => {
            // eslint-disable-next-line
            console.error(`Exiting updateContextTypeOnServer, error: ${error}`);
        });
};

export const initApp = (initialState, shouldRender = true) => {
    // In Prox flow, with LIPP integration, heliosnodeweb won't be able to pass context-type via mayfly.
    // Since they redirect to cape once flow is returned from LIPP and no client side code executes at that time.
    // Hence we need to manually check based on window.name, if it starts with 'PPFrame' its MB flow.
    // 'contextType' contains the information whether its full context or mini browser.
    // (iframe is obsolete for CAPE as eBay completely migrated to mini browser during August 2017)
    if (_.get(initialState, 'serverData.flow') === FLOW_TYPE.PROX) {

        if (window.name && window.name.indexOf(WINDOW_NAME_PPFRAME) === 0) {
            _.set(initialState, 'serverData.contextType', CONTEXT_TYPE.MB_CONTEXT);
        } else {
            _.set(initialState, 'serverData.contextType', CONTEXT_TYPE.FULL_CONTEXT);
        }

        updateContextTypeOnServer(initialState);
    }

    setupReturnBehavior();

    const app = <App initialState={initialState} />;
    return shouldRender
        ? ReactDOM.render(app, document.getElementById('cape-react-app'))
        : app;
};

export default initApp;
window.initApp = initApp;
